import { FC, ReactNode } from 'react';

export type TabPaneProps = {
  title: ReactNode;
  disabled?: boolean;
  children?: ReactNode;
};

export const TabPane: FC<TabPaneProps> = () => {
  return null;
};
